<template>
  <div class="pa-5">
    <AppointmentCanceledInfo :appointment="appointment" />
    <AppointmentBasicInfo :appointment="appointment" isAdmin />
    <AppointmentMeetingInfo :appointment="appointment" />
    <AppointmentRealties :appointment="appointment" />
    <AppointmentConfirmation :appointment="appointment" />
    <AppointmentHostAndVisitor :appointment="appointment" />
    <AppointmentOperator :appointment="appointment" />
    <AppointmentAdditionalInfo :appointment="appointment" />
    <AppointmentFilesTerm :showClickSignButton="true" />

    <v-divider class="my-8" />

    <h2 class="mb-8">
      {{ $t('appointment.label.files') }}
      <v-btn
        v-if="adminAppointmentFiles.length >= 1"
        @click="openModal('DELETE_ALL_APPOINTMENT_FILES')"
        elevation="0"
        class="ml-5"
        color="red"
        dark
        small
      >
        {{ $t('appointment.buttons.deleteAll') }}
      </v-btn>
      <v-btn
        v-if="adminAppointmentFilesToDelete.length >= 1"
        @click="openModal('DELETE_SELECTED_APPOINTMENT_FILES')"
        elevation="0"
        class="ml-5"
        color="red"
        outlined
        small
      >
        {{ $t('appointment.buttons.deleteSelected') }}
      </v-btn>
    </h2>

    <AdminAppointmentFilesUpload />

    <v-divider class="my-8" />

    <h2 class="mb-8">
      {{ $t('appointment.label.outputs') }}
      <v-btn
        v-if="adminAppointmentOutputs.length >= 1"
        @click="openModal('DELETE_ALL_APPOINTMENT_OUTPUTS')"
        elevation="0"
        class="ml-5"
        color="red"
        dark
        small
      >
        {{ $t('appointment.buttons.deleteAll') }}
      </v-btn>
      <v-btn
        v-if="adminAppointmentOutputsToDelete.length >= 1"
        @click="openModal('DELETE_SELECTED_APPOINTMENT_OUTPUTS')"
        elevation="0"
        class="ml-5"
        color="red"
        outlined
        small
      >
        {{ $t('appointment.buttons.deleteSelected') }}
      </v-btn>
    </h2>

    <AdminAppointmentOutputsUpload />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import {
  mailto,
  whatsApp,
  catalogMonetary,
} from '@/util/catalog'

import AppointmentBasicInfo from '@/components/appointment/details/AppointmentBasicInfo'
import AppointmentCanceledInfo from '@/components/appointment/details/AppointmentCanceledInfo'
import AppointmentMeetingInfo from '@/components/appointment/details/AppointmentMeetingInfo'
import AppointmentHostAndVisitor from '@/components/appointment/details/AppointmentHostAndVisitor'
import AppointmentConfirmation from '@/components/appointment/details/AppointmentConfirmation'
import AppointmentOperator from '@/components/appointment/details/AppointmentOperator'
import AppointmentRealties from '@/components/appointment/details/AppointmentRealties'
import AppointmentAdditionalInfo from '@/components/appointment/details/AppointmentAdditionalInfo'

import AdminAppointmentFilesUpload from '@/components/appointment/AdminAppointmentFilesUpload'
import AdminAppointmentOutputsUpload from '@/components/appointment/AdminAppointmentOutputsUpload'
import AppointmentFilesTerm from '@/components/appointment/AppointmentFilesTerm'
import InformationTooltip from '@/components/app/InformationTooltip'

export default {
  name: 'AdminAppointmentServiceDetails',

  components: {
    AppointmentCanceledInfo,
    AppointmentBasicInfo,
    AppointmentMeetingInfo,
    AppointmentHostAndVisitor,
    AppointmentOperator,
    AppointmentRealties,
    AppointmentConfirmation,
    AppointmentAdditionalInfo,

    AdminAppointmentOutputsUpload,
    AdminAppointmentFilesUpload,
    AppointmentFilesTerm,
    InformationTooltip,
  },

  data() {
    return {
      formatCurrency: catalogMonetary,
      whatsApp,
      mailto,
      moment,
    }
  },

  computed: {
    ...mapGetters([
      'appointment',
      'adminAppointmentFiles',
      'adminAppointmentOutputs',
      'adminAppointmentFilesToDelete',
      'adminAppointmentOutputsToDelete',
    ]),
  },

  methods: {
    ...mapActions(['openModal']),
  },
}
</script>
